<template>
  <div v-if="$route.query.userId">
    <div class="header">
      <img
        :src="`${publicPath}assets/images/trebel-yellow.png`"
        alt="TREBEL Logo"
        class="trebel-logo"
      />
    </div>
    <div class="code-confirmation">
      <div class="text">
        <p>Your account has been successfully deleted.</p>
      </div>
    </div>
    <div class="footer">
      <div class="social-links">
        <a href="https://www.instagram.com/trebelmx"
          ><img
            :src="`${publicPath}assets/images/Instagram.png`"
            alt="instagram"
            class="social-icon"
        /></a>
        <a href="https://www.facebook.com/trebelmx"
          ><img
            :src="`${publicPath}assets/images/Facebook1.png`"
            alt="facebook"
            class="social-icon"
        /></a>
        <a
          href="https://www.linkedin.com/company/trebelmusic/posts/?feedView=all"
          ><img
            :src="`${publicPath}assets/images/Linkedin.png`"
            alt="linkedin"
            class="social-icon"
          />
        </a>
        <a href="https://www.tiktok.com/@trebelmx"
          ><img
            :src="`${publicPath}assets/images/Tiktok.png`"
            alt="tiktok"
            class="social-icon"
        /></a>
        <a href="https://www.youtube.com/channel/UClmDcKB8ekgS9IbNJIUWETQ"
          ><img
            :src="`${publicPath}assets/images/Youtube.png`"
            alt="youtube"
            class="social-icon"
        /></a>
        <a href="https://twitter.com/trebelmx"
          ><img
            :src="`${publicPath}assets/images/Twitter.png`"
            alt="twitter"
            class="social-icon"
        /></a>
      </div>
      <div class="app-links">
        <img
          :src="`${publicPath}assets/images/android.png`"
          alt="Google Play"
          class="app-icon"
          @click="redirectPlayStore"
        />
        <img
          :src="`${publicPath}assets/images/ios.png`"
          alt="App Store"
          class="app-icon"
          @click="rediretAppStore"
        />
      </div>
    </div>
  </div>
  <div v-else>
    <p>Invalid URL. Please try again.</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      code: "",
      errorMessage: "",
      showSuccessDialog: false
    };
  },
  methods: {
    async redirectPlayStore() {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.mmm.trebelmusic";
    },
    async rediretAppStore() {
      window.location.href =
        "https://apps.apple.com/us/app/trebel-music-download-songs/id912390687";
    }
  }
};
</script>

<style scoped>
.header {
  position: absolute;
  top: 0;
  background: #fdf203;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.code-confirmation {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background-color: #fff; /* Light background color */
  font-family: sans-serif;
}

.confirmation-container {
  background-color: #f0f0f0;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 400px;
  width: 90%; /* Responsive width */
}
.text {
  font-size: 24px;
  max-width: 400px;
  text-align: center;
  font-family: Montserrat;
  font-weight: 500;
}
.subText {
  font-size: 18px;
}
.trebel-logo {
  width: 150px;
  margin: 20px;
}

h1 {
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 10px;
}

p {
  color: #666;
  margin-bottom: 15px;
  line-height: 1;
}

label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-weight: 500;
}

input {
  width: calc(100% - 22px);
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 50px;
  font-size: 1rem;
  box-sizing: border-box;
}

.remove-button {
  background-color: #ffcc00;
  color: #333;
  padding: 12px 35px;
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 10px;
}

.remove-button:hover {
  background-color: #ffdb4d;
}

.footer {
  display: flex;
  justify-content: space-around;
  position: absolute;
  bottom: 0;
  width: 100%;
  background: #000;
  z-index: 99;
  align-items: center;
}

.app-links {
  display: flex;
  justify-content: center;
  margin: 15px;
}

.app-icon {
  max-width: 130px;
  margin: 0 10px;
  cursor: pointer;
}

.success-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Ensure dialog is on top */
}

.dialog-content {
  background-color: rgba(0, 0, 0, 0.9);
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  max-width: 250px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.success-icon {
  width: 80px;
  height: 80px;
  margin-bottom: 20px;
}

.ok-button {
  background-color: #ffcc00;
  color: #333;
  padding: 8px 25px;
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
}

.ok-button:hover {
  background-color: #ffdb4d;
}

.error-message {
  color: red;
  font-size: 0.85rem;
  margin-top: 5px;
}
.dialog-content .title {
  font-family: Gotham;
  font-weight: 350;
  font-size: 18px;
  color: #fff;
}
.dialog-content .text {
  font-family: Gotham;
  font-weight: 350;
  font-size: 14px;
}
.content .text {
  font-family: Montserrat;
  font-weight: 500;
  font-size: 12px;
  text-align: left;
}
.social-icon {
  margin: 0 5px;
}
</style>
